import { useState } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { apiClient } from 'modules/core/lib/mobx-rest'

export interface PreviewVariables {
  [key: string]: string
}

interface Props {
  id: number
  employeeId?: number | null | undefined
}

interface Result {
  loading: boolean
  variableValues: PreviewVariables | undefined
}

const url = `/templates/preview_variables`

export const usePreviewVariablesDocumentTemplate = ({ id, employeeId }: Props): Result => {
  const [variableValues, setVariablesValues] = useState<PreviewVariables | undefined>({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!employeeId) {
      setVariablesValues(undefined)
      return
    }

    const previewVariablesDocumentTemplate = async () => {
      const result = await apiClient().get(url, { id: id, employee_id: employeeId })

      setVariablesValues(result)
    }

    previewVariablesDocumentTemplate()
  }, [id, employeeId])

  return { variableValues, loading }
}
